import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Link } from "react-router-dom";

type CategoryTabSectionProps = {
  categories: { id: string; label: string }[];
  selectedCategoryId: string;
  onSelectCategory: (id: string) => void;
  language: "en" | "ar";
};

const MAX_ROWS = 2;
const CATEGORIES_PER_ROW = 5; // Adjust based on your design needs

const CategoryTabSection = ({
  categories,
  selectedCategoryId,
  onSelectCategory,
  language,
}: CategoryTabSectionProps) => {
  const isRTL = language === "ar";
  const maxVisible = MAX_ROWS * CATEGORIES_PER_ROW;
  const visibleCategories = categories.slice(0, maxVisible);
  const hasMoreCategories = categories.length > maxVisible;

  // Split categories into rows
  const rows = [];
  for (let i = 0; i < visibleCategories.length; i += CATEGORIES_PER_ROW) {
    rows.push(visibleCategories.slice(i, i + CATEGORIES_PER_ROW));
  }

  return (
    <div className="flex w-full flex-col items-center px-0 mb-10 sm:px-4">
      <div className="w-full max-w-5xl flex flex-col items-center gap-4">
        {/* Categories rows */}
        <div className="flex flex-col gap-2 w-full items-center">
          {rows.map((row, rowIndex) => (
            <TabsList
              key={rowIndex}
              className={`
                flex h-auto min-h-10 w-full flex-wrap gap-2 bg-transparent p-0
                ${isRTL ? "flex-row-reverse justify-center" : "flex-row justify-center"}
                ${rowIndex >= MAX_ROWS ? "hidden" : ""}
              `}
            >
              {row.map((category) => (
                <TabsTrigger
                  key={category.id}
                  value={category.id}
                  onClick={() => onSelectCategory(category.id)}
                  className={`
                    h-auto max-w-full flex-shrink-0 whitespace-normal text-center text-sm leading-snug px-4 py-2 rounded-full transition-colors
                    border border-gray-200 dark:border-gray-700
                    text-gray-700 dark:text-gray-300
                    hover:bg-black hover:text-white
                    data-[state=active]:!bg-nexus-brand
                    data-[state=active]:!text-white 
                    data-[state=active]:!border-nexus-brand
                  `}
                >
                  {category.label}
                </TabsTrigger>
              ))}
            </TabsList>
          ))}
        </div>

        {/* Show more link - positioned below categories */}
        {hasMoreCategories && (
          <div className="w-full text-center mt-2">
            <Link
              to="/blog/categories"
              className="inline-block text-nexus-teal hover:underline text-sm"
            >
              {language === "ar" ? "عرض المزيد من التصنيفات" : "Show more categories"}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryTabSection;
